// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import constant from './constants'
import store from './store'
import i18n from './lang.js'
import Mixin from './mixins/index.js'
import disposition from './plugins/disposition.js'
import VModal from 'vue-js-modal'
import * as uiv from 'uiv'

import VueSession from 'vue-session'
import VueMoment from 'vue-moment'
import axios from './axios.js'
import VueAxios from 'vue-axios'
import cart from './plugins/cart.js'
import Notifications from 'vue-notification'
import VueLodash from 'vue-lodash'
import VueAuth from '@websanova/vue-auth'
import Nl2br from 'vue-nl2br'
import ErrorHandler from './plugins/ErrorHandler'
import WarnHandler from './plugins/WarnHandler'
import VueAnalytics from 'vue-analytics'

Vue.router = router
Vue.use(VueAxios, axios)
Vue.axios.defaults.headers.post['Content-Type'] = 'application/json'
Vue.axios.defaults.headers.common['Client'] = constant.CLIENT_ID
Vue.axios.defaults.headers.common['Lang'] = constant.DEFAULT_LANGUAGE
Vue.use(VueAuth, {
  auth: {
    request: function (req, token) {
      let info = JSON.parse(unescape(atob(token)))
      this.options.http._setHeaders.call(this, req, {'x-token': info.token})
    },

    response: function (res) {
      if (res.data.data) {
        if (typeof res.data.data.item !== 'undefined' && res.data.data.item != null && res.data.data.item.token) {
          let info = res.data.data.item
          return btoa(escape(JSON.stringify(info)))
        }
      }
    }
  },
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  refreshData: {enabled: false},
  loginData: {
    url: process.env.version + '/product-customer/login',
    method: 'POST',
    redirect: true,
    fetchUser: false
  },
  fetchData: {
    enabled: false,
    success: function () {
      let info = Vue.auth.token()

      if (info) {
        info = JSON.parse(unescape(atob(info)))
      }
      Vue.auth.user(info)
    }
  },
  logoutData: {
    url: process.env.version + '/product-customer/logout',
    method: 'POST',
    redirect: false,
    makeRequest: true
  },
  notFoundRedirect: {
    path: '/',
  },
  forbiddenRedirect: {
    path: '/error-404'
  },
  authRedirect: {
    enabled: false
  }
})

Vue.component('async-component', function (resolve) {
  require([
    '@/components/popup/ModalPizza.vue',
    '@/components/popup/ModalPizzaHalf.vue'
  ], resolve)
});

const options = {name: 'lodash'}
Vue.config.productionTip = false
Vue.config.performance = true
Vue.config.devtools = true
//Vue.config.errorHandler = (err, vm, info) => ErrorHandler.write(err, vm, info)
//Vue.config.warnHandler = (msg, vm, trace)  => WarnHandler(msg, vm, trace)
Vue.prototype.$const = constant

Vue.mixin(Mixin)
Vue.use(disposition)
Vue.use(VueSession, {persist: true})
Vue.use(cart)
Vue.use(VueLodash, options)
Vue.use(uiv)
Vue.use(Notifications)
Vue.use(VModal, {dynamic: true, injectModalsContainer: true, dialog: true})

/* Component Layouts */
Vue.component('main-layout', function (resolve) {
  require(['./layouts/Main.vue'], resolve)
});
Vue.component('home-layout', function (resolve) {
  require(['./layouts/Home.vue'], resolve)
});
Vue.component('simple-layout', function (resolve) {
  require(['./layouts/Simple.vue'], resolve)
});
Vue.component('combo-layout', function (resolve) {
  require(['./layouts/Combo.vue'], resolve)
});
Vue.component('home-landing-layout', function (resolve) {
  require(['./layouts/HomeLanding.vue'], resolve)
});
Vue.component('landing-layout', function (resolve) {
  require(['./layouts/Landing.vue'], resolve)
});
Vue.component('voucher-layout', function (resolve) {
  require(['./layouts/Vouchers.vue'], resolve)
});
Vue.component('home-footer', function (resolve) {
  require(['./components/home/HomeFooterJP.vue'], resolve)
});
Vue.component('home-top', function (resolve) {
  require(['./components/home/HomeTop.vue'], resolve)
});
Vue.component('modal-notify', function (resolve) {
  require(['./components/popup/ModalNotify.vue'], resolve)
});
Vue.component('not-found', function (resolve) {
  require(['./layouts/NotFound'], resolve)
});
Vue.component('nl2br', Nl2br)


Vue.use(VueAnalytics, {
  id: process.env.GOOGLE_ANALYTICS_KEY,
  checkDuplicatedScript: true
})

/* Vue moment */
Vue.use(VueMoment)
// Vue event bus
const EventBus = new Vue()
Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function () {
      return EventBus
    }
  }
})

/* eslint-disable no-new */
const main = new Vue({
  el: '#app',
  i18n,
  store,
  router,
  template: '<App/>',
  components: {App},
  mounted() {
    this.$cart.init(this)
    if (Vue.router.history.current.name && Vue.router.history.current.name !== "vouchers") {
      this.loadPage()
    }
    document.dispatchEvent(new Event('render-event'))
  },
  created: function () {
    // change langues
    this.$session.set('client', constant.CLIENT_ID)
    this.$session.set('google-key-api', constant.GOOGLE_API_KEY)
    if (!this.$session.get('lang')) {
      this.$session.set('lang', this.$i18n.locale)
    }
    this.$i18n.locale = this.$session.get('lang') || this.$i18n.locale
    if (!this.$session.get('lang')) {
      this.$session.set('lang', this.$i18n.locale)
    }
    Vue.axios.defaults.headers.common['Lang'] = this.$i18n.locale
    this.importPlugin(process.env.GTM_KEY)
    this.importJSOMLD()
  },
  methods: {
    loadPage() {
      this.$cart.getDetail(this)
    },
    importPlugin (gtmKey) {
      (function (w, d, s, l, i, elementid) {
        w[l] = w[l] || []
        w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'})
        // eslint-disable-next-line one-var
        var f = d.getElementsByTagName(s)[0]
        if (d.getElementById(elementid)) return
        // eslint-disable-next-line one-var
        var j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''
        j.async = true
        j.id = elementid
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
        f.parentNode.insertBefore(j, f)
        let node = d.createElement('noscript')
        let head = d.getElementsByTagName('head')[0]
        node.innerHTML = '<iframe src="https://www.googletagmanager.com/ns.html?id=' + gtmKey + '" height="0" width="0" style="display:none;visibility:hidden"></iframe>'
        head.appendChild(node)
      })(window, document, 'script', 'dataLayer', gtmKey, 'gtm-id-elementss')
    },
    importJSOMLD () {
      let param = ''
      let action = this.getCurrentPath()
      if (action) {
        action = action.replace(/^\/+/g, '').replace(/\/+$/g, '').replace(/\//g, '_').replace(/-/g, '_')
        param += action
      }
      const obj = this.$const.DATA_JSONLD[param]
      const html = this.$const.DATA_BREADCRUMB[param]
      if (obj) {
        (function (w, d, s, elementid) {
          // eslint-disable-next-line one-var
          var f = d.getElementsByTagName(s)[0]
          if (d.getElementById(elementid)) return
          var breadcrumb = document.getElementById('breadcrumb')
          breadcrumb.innerHTML = html
          // eslint-disable-next-line one-var
          var j = d.createElement(s)
          j.type = 'application/ld+json'
          j.innerHTML = JSON.stringify(obj)
          f.parentNode.insertBefore(j, f)
        })(window, document, 'script', 'jsonld')
      }
    }
  }
})
export default main



// WEBPACK FOOTER //
// ./src/main.js